<template>
	
	<div class="wizard-component data-input">

		<div class="inputs">
			<div class="input-container" v-for="input in inputFields">
				<p class="subject">{{ input.subject }}</p>
				<div class="input-inner" :class="input.class">
					<input :type="input.type" name="">
					<span v-if="input.class === 'pricing-input'" class="label-after">Kr.</span>
					<span v-else-if="input.class === 'area-input'" class="label-after">m<sup>2</sup></span>
					<span v-else-if="input.class === 'date-input'" class="label-after">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
						  <path class="fill-purple" d="M2693,712h-6a2,2,0,0,0-4,0h-16a2,2,0,0,0-4,0h-6a2,2,0,0,0-2,2v34a2,2,0,0,0,2,2h36a2,2,0,0,0,2-2V714A2,2,0,0,0,2693,712Zm-2,34h-32V726h32v20Zm0-24h-32v-6h4a2,2,0,0,0,4,0h16a2,2,0,0,0,4,0h4v6Zm-26,8h4v4h-4v-4Zm8,0h4v4h-4v-4Zm8,0h4v4h-4v-4Zm-16,8h4v4h-4v-4Zm8,0h4v4h-4v-4Zm8,0h4v4h-4v-4Z" transform="translate(-2655 -710)"/>
						</svg>
					</span>
				</div>
				
				<span class="small-text">{{ input.comment }}</span>
			</div>
		</div>

	</div>

</template>


<script>
	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {
	

		data: () => ({
			inputFields: [
				{
					subject: 'Just a normal field',
					type: 'text'
				},
				{
					subject: 'Monthly rent',
					class: 'pricing-input',
					type: 'text',
					comment: 'Monthly rent excl. use'
				},
				{
					subject: 'Occupancy date',
					class: 'date-input',
					type: 'date'
				},
				{
					subject: 'Size',
					class: 'area-input',
					type: 'number',
					comment: 'Beboelsesareal angivet i BBR'
				}
			]

		})

	}
</script>


<style></style>